import styled, { css } from 'styled-components';
import Spinner, { SpinnerText } from '../../../../spinner';
const SPINNER_TOP = '35%';
/**
 * ReceiptSpinner
 */
export const receiptSpinnerStyles = () => css `
	opacity: 1;
	position: absolute;
	top: ${SPINNER_TOP};
	left: 50%;
	transform: translateX(-50%);

	${SpinnerText} {
		white-space: nowrap;
	}
`;
export const StyledReceiptSpinner = styled(Spinner) `
	${receiptSpinnerStyles}
`;
